// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index-module__fitLoader--2mYL_,.index-module__loader--1Kv-i{position:absolute;text-align:center;width:100%}.index-module__fitLoader--2mYL_{top:0;left:0;height:100%}.index-module__loader--1Kv-i{top:calc(50% - 25px);height:50px}.index-module__spin--3-3X7{display:inline-block;width:40px;height:40px;border:2px solid #fff;border:2px solid hsla(0,0%,100%,.2);border-top-color:#004ba4;border-radius:50%;animation:index-module__spin--3-3X7 1s linear infinite}.index-module__fitLoader--2mYL_ .index-module__spin--3-3X7{width:100%;height:100%}@keyframes index-module__spin--3-3X7{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);
// Exports
exports.locals = {
	"fitLoader": "index-module__fitLoader--2mYL_",
	"loader": "index-module__loader--1Kv-i",
	"spin": "index-module__spin--3-3X7"
};
module.exports = exports;
